import { withRequestActivity } from "../lib/requestActivity";

async function explainBlobError(error) {
  const body = error?.response?.data;
  if (body instanceof Blob) {
    try {
      const text = typeof body.text === "function" ? await body.text() : await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(body);
      });
      error.response.data = JSON.parse(text);
    } catch (_) { /* Keep the HTTP error when the response is not JSON. */ }
  }
  return error;
}

async function saveDownload(client, path, filename, config = {}) {
  let response;
  try {
    response = await client.get(path, { ...config, responseType: "blob" });
    if (response.status != null && (response.status < 200 || response.status >= 300)) {
      const error = new Error(`Download failed (${response.status})`);
      error.response = response;
      throw error;
    }
  } catch (error) { throw await explainBlobError(error); }
  // A completed response may belong to a previous tenant, identity or filter scope.
  if (config.signal?.aborted) throw new DOMException("Download cancelled", "AbortError");
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  const resolvedFilename = typeof filename === "function" ? filename(response) : filename;
  anchor.download = resolvedFilename;
  document.body.appendChild(anchor);
  try { anchor.click(); }
  finally { anchor.remove(); setTimeout(() => URL.revokeObjectURL(url), 0); }
  return resolvedFilename;
}

export function downloadFile(client, path, filename, config = {}) {
  const action = () => saveDownload(client, path, filename, config);
  return config.globalLoader === true ? withRequestActivity(action) : action();
}
